export default __webpack_public_path__ + "static/media/polygon_up_white.9ab7f48d.svg";